export default __webpack_public_path__ + "static/media/partners.38a8731d.svg";